module.exports = __webpack_public_path__ + "img/14.e2e0f7a5.jpg";